import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgChevronUpIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        d="m16.015 11.007.707-.707-.707-.706-.707.706zm-.707.707 8.485 8.486 1.414-1.415-8.485-8.485zm0-1.414-8.5 8.485L8.221 20.2l8.5-8.485z"
      />
    </svg>,
  );
};
export default SvgChevronUpIcon;
